export default __webpack_public_path__ + "static/media/model_3_safety_hero.2848d24e.png";